import { useCallback } from "react";
import { ActionsAdAssistant } from "../../../Actions/ActionsAdAssistant/ActionsAdAssistant";

/**
 * Custom hook to update multiple properties in media assets.
 * @param {Object} currentAd - The current ad object.
 */
export const useUpdateStoreCurrentAd = (currentAd) => {
  const updateStoreCurrentAd = useCallback(
    (updates) => {
      const newCurrentAd = { ...currentAd, ...updates };
      ActionsAdAssistant.setCurrentAd({
        ...newCurrentAd
      });
    },
    [currentAd]
  );

  return updateStoreCurrentAd;
};
